import { JobDetailsTypes, JobResultTypes, JobStatus, JobType } from '../../api/jobs.dao';
import JobsRegistry from './implementations/jobs-registry';
import { JobConfiguration } from './job-configuration';
import { IJobRunner, JobDtoType } from './index';


export abstract class JobRunner implements IJobRunner {
    private getJobConfig(): JobConfiguration { return JobsRegistry[this.type]; }

    protected constructor(readonly id: number, readonly type: JobType, private readonly jobDto: JobDtoType) {}

    public get description(): string { return this.getJobConfig().description; }
    public get name(): string { return this.getJobConfig().name; }

    public inProgress(): boolean { return this.jobDto.jobStatus === JobStatus.InProgress; }
    public isCompleted(): boolean { return this.jobDto.jobStatus === JobStatus.Completed; }
    public isFailed(): boolean { return this.jobDto.jobStatus === JobStatus.Failed; }
    public getDetails(): JobDetailsTypes { return this.jobDto.jobDetails; }
    public getResult(): JobResultTypes { return this.jobDto.result; }
    public getStatus(): JobStatus { return this.jobDto.jobStatus; }
}
